import * as React from 'react';

import * as style from './TopPromosIllustration.css';

export interface ITopPromosIllustrationProps {
  logosUrls: string[];
}

export const TopPromosIllustration: React.FC<ITopPromosIllustrationProps> = ({ logosUrls }) => {
  return (
    <div className={style['container']} data-testid="TopPromosIllustration">
      {logosUrls.map((url, i) => (
        <div key={`${url}/${i}`} className={style['logo']} style={{ backgroundImage: `url(${url})` }} />
      ))}
    </div>
  );
};
